<header>
    <h3>{{'statistics' |  translate}}</h3>
</header>
<div class="ml-5 md:px-5 md:ml-0">
    <div class="grid p-fluid">
        <div class="col-12 grid md:col-10 lg:col-8" *ngIf="profile.monthPosition != undefined">
            <span class="col-1 py-0"><i class="icon-trophy"></i></span>
            <span class="col">{{'month_position' | translate}}:</span>
            <span class="col-4">{{profile.monthPosition}}</span>
        </div>
        <div class="col-12 grid md:col-10 lg:col-8" *ngIf="profile.badgeTrophy != undefined">
            <span class="col-1 py-0"><i class="icon-shield"></i></span>
            <span class="col">{{'badge_earned' | translate}}:</span>
            <span class="col-4">{{identifyBadge()}}</span>
        </div>
        <div class="col-12 grid md:col-10 lg:col-8">
            <span class="col-1 py-0"><i class="icon-circle-dollar"></i></span>
            <span class="col">{{'published_deals' | translate}}:</span>
            <span class="col-4">{{profile.dealCount}}</span>
        </div>
        <div class="col-12 grid md:col-10 lg:col-8">
            <span class="col-1 py-0"><i class="icon-message"></i></span>
            <span class="col">{{'comments' | translate}}:</span>
            <span class="col-4">{{profile.commentCount}}</span>
        </div>
        <div class="col-12 grid md:col-10 lg:col-8">
            <span class="col-1 py-0"><i class="icon-hearth"></i></span>
            <span class="col">{{'votes'| translate}}:</span>
            <span class="col-4">{{profile.voteCount}}</span>
        </div>
        <div class="col-12 grid md:col-10 lg:col-8">
            <span class="col-1 py-0"><i class="icon-calendar"></i></span>
            <span class="col">{{'signup_date' | translate}}:</span>
            <span class="col-4">{{profile.user_date | date: 'longDate'}}</span>
        </div>
    </div>
</div>
